import { costBreakdownV2WidgetSetupTotalDataWithIdsSelector } from "./costBreakdownV2WidgetSetupTotalDataWithIdsSelector";
import { RootState } from "../../../../../store";

export const costBreakdownV2WidgetSetupTotalDataCountSelector = (
  state: RootState,
): number | undefined => {
  const data = costBreakdownV2WidgetSetupTotalDataWithIdsSelector(state);

  return data?.length;
};
